<div class="modal-header p-dialog-header flex-between">
  <div class="d-flex align-items-center">
    <i *ngIf="loadList === 1" class="pi pi-arrow-left me-2" (click)="goBackTablePage()"></i>
    <span class="text-16 font-medium ms-3">{{ title }}</span>
  </div>
  <i class="pi pi-times w-24px" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()"></i>
</div>

<div *ngIf="loadList === 0" class="modal-body pt-0">
  <div class="container text-center px-0" style="padding: 10px;">
    <div class="flex-between mt-1 ms-2 mb-2">
      <div class="custella-dashboard-top-right d-flex ms-auto">
        <button class="btn-list-icon ms-2" [pTooltip]="translate?.general.buttons.refresh.singular" tooltipPosition="bottom" (click)="loadJourneys()">
          <i class="fa-regular fa-arrows-rotate"></i>
        </button>
        <div class="p-inputgroup search ms-2">
          <span class="p-input-icon-right">
            <input type="text" class="w-100" pInputText autocomplete="off" [placeholder]="translate?.general.buttons.search.singular" [(ngModel)]="searchValue" (keydown.enter)="quickSearch()" (keyup)="onSearch()" />
            <i *ngIf="searchValueData" class="p-autocomplete-clear-icon pi pi-times" (click)="onClear()"></i>
          </span>
          <button type="button" pButton icon="fa-regular fa-magnifying-glass" (click)="quickSearch()"></button>
        </div>
        <p-button [label]="translate?.general.buttons.new.singular" icon="fa-regular fa-plus" (onClick)="openNewForm()" styleClass="ms-2 h-32"></p-button>
      </div>
    </div>

    <div class="position-relative fw-normal d-flex display-table">
      <div class="border ag-grid-table-full" style="height: 400px;">
        <ag-grid-angular
          style="height: 100%;"
          class="ag-theme-balham"
          [headerHeight]="33"
          [rowHeight]="27"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [defaultColDef]="defaultColDef"
          [rowData]="visibleJourneys"
          [components]="frameworkComponents"
          [overlayNoRowsTemplate]="overlayNoRowsTemplate"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        <div class="col-12">
          <p class="ag-record-row-summary-panel padds text-end">{{ totalRecord }}&nbsp;{{ translate?.general.messages.records }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loadList === 1" class="modal-body p-0">
  <div class="custella-form-container height-80 overflow-scroll position-relative d-block m-0">
    <div class="custella-form-container-title-two text-14 font-medium">Journey Details</div>
    <div class="custella-form-container-content">
      <div class="custella-content-row mb-3">
        <div class="custella-content-row-input col-6">
          <span class="custella-content-row-input-title mandatory">Date &amp; Time</span>
          <p-calendar
            [(ngModel)]="newJourney.dateTime"
            [ngModelOptions]="{standalone: true}"
            dateFormat="dd/mm/yy"
            hourFormat="12"
            [showTime]="true"
            [showSeconds]="false"
            [showIcon]="false"
            [placeholder]="translate?.general.messages.none"
            appendTo="body"
            [yearNavigator]="true"
            yearRange="2000:2030">
          </p-calendar>
          <div class="text-10 p-error" *ngIf="formSubmitted && !newJourney.dateTime">
            <span>{{ translate?.general.validationFE.requiredField }}</span>
          </div>
        </div>
        <div class="custella-content-row-input col-6">
          <span class="custella-content-row-input-title mandatory">User</span>
          <p-dropdown
            [options]="users"
            optionLabel="firstName"
            optionValue="id"
            name="userId"
            [placeholder]="translate?.general.messages.none"
            [(ngModel)]="newJourney.userId"
            [showClear]="false"
            appendTo="body"
            (onChange)="onUserChange()">
            <ng-template let-user pTemplate="item">
              <div>{{ user.firstName }} {{ user.lastName }}</div>
            </ng-template>
          </p-dropdown>
          <div class="text-10 p-error" *ngIf="formSubmitted && newJourney.userId == null">
            <span>{{ translate?.general.validationFE.requiredField }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="custella-form-container-title-two text-14 font-medium">Select Start and End Location</div>
    <div class="custella-form-container-content">
      <div class="custella-content-row pe-0 mb-3">
        <div class="custella-content-row-input col-12">
          <span class="custella-content-row-input-title mandatory">From</span>
          <div class="d-flex align-items-center">
            <div class="col-10 d-flex p-0" *ngIf="newJourney.fromType == 'Task'">
              <p-dropdown
                [options]="locationByTaskData"
                [placeholder]="translate?.general.messages.none"
                [(ngModel)]="newJourney.fromTaskId"
                (onChange)="getTaskDetail('startLocation', newJourney.fromTaskId)"
                [showClear]="true"
                appendTo="body"
                optionLabel="customeName"
                optionValue="id"
                class="col-6 ps-0">
              </p-dropdown>
              <input pInputText autocomplete="off" readonly [(ngModel)]="newJourney.startLocation.address" [placeholder]="translate?.general.messages.none" />
            </div>
            <div class="col d-flex p-0" *ngIf="newJourney.fromType != 'Task'">
              <input #fromAddressSearch id="input_JoJourneyFrom" pInputText class="w-100" autocomplete="off" [(ngModel)]="newJourney.startLocation.address" [placeholder]="translate?.general.messages.none" (keyup)="getPlaceApiCall($event)" />
            </div>
            <div class="d-flex align-items-center justify-content-end ms-auto">
              <button type="button" class="btn-list-icon ms-2" (click)="setStartLocation('Home')" [pTooltip]="translate?.task.fields.home.singular" tooltipPosition="top">
                <i class="fa-regular fa-house"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setStartLocation('Office')" [pTooltip]="translate?.task.fields.office.singular" tooltipPosition="top">
                <i class="fa-regular fa-briefcase"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setStartLocation('Task')" [pTooltip]="translate?.task.label.singular" tooltipPosition="top">
                <i class="fa-regular fa-circle-check"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setStartLocation('Current Location')" [pTooltip]="translate?.task.fields.currentLocation.singular" tooltipPosition="top">
                <i class="fa-regular fa-location-dot"></i>
              </button>
            </div>
          </div>
          <div class="text-10 p-error" *ngIf="formSubmitted && !newJourney.startLocation.address">
            <span>{{ translate?.general.validationFE.requiredField }}</span>
          </div>
        </div>
      </div>
      <div class="custella-content-row pe-0 mb-3">
        <div class="custella-content-row-input col-12">
          <span class="custella-content-row-input-title mandatory">To</span>
          <div class="d-flex align-items-center">
            <div class="col-10 d-flex p-0" *ngIf="newJourney.toType == 'Task'">
              <p-dropdown
                [options]="locationByEndTaskData"
                [placeholder]="translate?.general.messages.none"
                [(ngModel)]="newJourney.toTaskId"
                (onChange)="getTaskDetail('endLocation', newJourney.toTaskId)"
                [showClear]="true"
                appendTo="body"
                optionLabel="customeName"
                optionValue="id"
                class="col-6 ps-0">
              </p-dropdown>
              <input pInputText autocomplete="off" readonly [(ngModel)]="newJourney.endLocation.address" [placeholder]="translate?.general.messages.none" />
            </div>
            <div class="col d-flex p-0" *ngIf="newJourney.toType != 'Task'">
              <input #toAddressSearch id="input_JoJourneyTo" pInputText class="w-100" autocomplete="off" [(ngModel)]="newJourney.endLocation.address" [placeholder]="translate?.general.messages.none" (keyup)="getPlaceApiCall1($event)" />
            </div>
            <div class="d-flex align-items-center justify-content-end ms-auto">
              <button type="button" class="btn-list-icon ms-2" (click)="setEndLocation('Home')" [pTooltip]="translate?.task.fields.home.singular" tooltipPosition="top">
                <i class="fa-regular fa-house"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setEndLocation('Office')" [pTooltip]="translate?.task.fields.office.singular" tooltipPosition="top">
                <i class="fa-regular fa-briefcase"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setEndLocation('Task')" [pTooltip]="translate?.task.label.singular" tooltipPosition="top">
                <i class="fa-regular fa-circle-check"></i>
              </button>
              <button type="button" class="btn-list-icon ms-2" (click)="setEndLocation('Current Location')" [pTooltip]="translate?.task.fields.currentLocation.singular" tooltipPosition="top">
                <i class="fa-regular fa-location-dot"></i>
              </button>
            </div>
          </div>
          <div class="text-10 p-error" *ngIf="formSubmitted && !newJourney.endLocation.address">
            <span>{{ translate?.general.validationFE.requiredField }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="custella-form-container-title-two flex-between">
      <span class="font-medium text-14">Calculate Duration &amp; Distance</span>
      <p-button [label]="translate?.general.buttons.calculate.singular" styleClass="p-button-secondary py-1" (onClick)="calculate()"></p-button>
    </div>
    <div class="custella-form-container-content">
      <div class="d-flex mb-3">
        <div class="custella-content-row-input me-5">
          <span *ngIf="distanceData" class="custella-content-row-input-title">Duration</span>
          <span class="custella-content-row-input-title jo-journey-metric">{{ distanceData?.message }}</span>
        </div>
        <div class="custella-content-row-input">
          <span *ngIf="distanceKM" class="custella-content-row-input-title">Distance</span>
          <span class="custella-content-row-input-title jo-journey-metric">{{ distanceKM }}{{ distanceKM ? ' KM' : '' }}</span>
        </div>
      </div>
    </div>

    <div class="custella-form-container-footer-two">
      <div class="d-flex align-items-center justify-content-end">
        <button type="button" class="custella-btn-white text-12 ms-2" (click)="goBackTablePage()">{{ translate?.general.buttons.cancel.singular }}</button>
        <p-button [label]="translate?.general.buttons.save.singular" (onClick)="saveJourney()" styleClass="ms-2 h-32"></p-button>
      </div>
    </div>
  </div>
</div>
